
export { Link } from "/vercel/path0/packages/ui/Link/index.tsx"